import React from 'react';
import PropTypes from 'prop-types';
import renderIf from 'render-if';
import cn from 'classnames';
import SchoolTile from 'components/SchoolTile';
import SchoolListView from 'components/SchoolListView';
import Nocontentfound from '../Tutorial/Nocontentfound';
import styles from '../DashboardView.scss';

const WishlistView = (props) => {
  const { contactedList, schools, wishList, inviteToCampList, addToList, fillQList, profileId,
          addToRequest, removeFromList, showCounterpopUp, addNotification, gridView,
          subscribed } = props;
  const renderNoContentFound = renderIf(wishList.size === 0 && subscribed);
  return (
    <div className={cn('col s12', styles.alignCenter)}>
      {renderNoContentFound(<Nocontentfound text="You don't have any items in wishlist." />)}
      {schools.map((item) => {
        const wishListId = wishList.indexOf(item.get('id'));
        const inWishList = wishListId > -1;
        const interested = contactedList.indexOf(item.get('id')) > -1;
        const fillQ = fillQList.indexOf(item.get('id')) > -1;
        const inviteToCamp = inviteToCampList.indexOf(item.get('id')) > -1;
        const show = wishListId > -1 && interested > -1;
        if (show) {
          return (
            <span>
              {gridView ?
                <SchoolTile
                  saSchool={item}
                  addToList={addToList}
                  profileId={profileId}
                  addToRequest={addToRequest}
                  inWishList={inWishList}
                  interested={interested}
                  removeFromList={removeFromList}
                  wishListId={wishListId}
                  showCounterScreen={showCounterpopUp}
                  {...props}
                  fillQ={fillQ}
                  inviteToCamp={inviteToCamp}
                  showSnackBar={val => addNotification(val)}
                  usedFor="schools"
                />
              :
                <SchoolListView
                  saSchool={item}
                  addToList={addToList}
                  profileId={profileId}
                  addToRequest={addToRequest}
                  inWishList={inWishList}
                  interested={interested}
                  removeFromList={removeFromList}
                  wishListId={wishListId}
                  showCounterScreen={showCounterpopUp}
                  {...props}
                  fillQ={fillQ}
                  inviteToCamp={inviteToCamp}
                  showSnackBar={val => addNotification(val)}
                  usedFor="schools"
                />
            }
            </span>
          );
        }
        return null;
      })}
    </div>
  );
};

WishlistView.propTypes = {
  addToList: PropTypes.func.isRequired,
  addToRequest: PropTypes.func.isRequired,
  wishList: PropTypes.shape.isRequired,
  contactedList: PropTypes.shape.isRequired,
  inviteToCampList: PropTypes.shape.isRequired,
  profileId: PropTypes.string.isRequired,
  removeFromList: PropTypes.func.isRequired,
  gridView: PropTypes.bool.isRequired,
  showCounterpopUp: PropTypes.func.isRequired,
  addNotification: PropTypes.func.isRequired,
  schools: PropTypes.shape.isRequired,
  fillQList: PropTypes.shape.isRequired,
  subscribed: PropTypes.bool.isRequired,
};

export default WishlistView;




// WEBPACK FOOTER //
// ./src/components/DashboardView/wishlist/wishlist.js